<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" :color="'success'" class="ml-3">
        <v-icon>{{ "mdi-plus-circle" }}</v-icon
        ><span>Upload TR</span>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title">Upload TR</slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="dialog = false" color="white"
              >mdi-window-close</v-icon
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col sm="12">
            <v-file-input label="Selecione o arquivo" v-model="file">
            </v-file-input>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="dialog = false"
          >Fechar</v-btn
        >
        <v-btn color="info" outlined text @click="onConfirm">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { referenceTermAPI } from "@/modules/reference-term";
import { mapActions } from "vuex";

export default {
  name: "AppModalUpload",
  props: {
    object: { type: Object, required: false },
    edit: { type: Boolean, required: false, default: false },
    large: { type: Boolean, required: false, default: false },
  },
  data() {
    return {
      file: "",
      dialog: false,
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    onConfirm() {
      if (this.file.length <= 0) {
        this.$notification.error(
          "Não é possível fazer upload do arquivo, favor selecionar um arquivo!"
        );
      }

      this.setLoading(true);

      let formData = new FormData();

      formData.append("file", this.file);

      referenceTermAPI
        .upload(formData)
        .then((resp) => {
          this.setLoading(false);
          this.dialog = false;
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao enviar o arquivo excel");
        });
    },
  },
  watch: {
    object(newValue, oldValue) {
      this.payload = newValue;
    },
  },
};
</script>
